import { Star } from "lucide-react";
import trustvilleBadgeImg from "@/assets/trustville-badge.webp";

interface TrustvilleBadgeProps {
  className?: string;
}

export const TrustvilleBadge = ({ className = "" }: TrustvilleBadgeProps) => {
  return (
    <a
      href="https://trustville.com/avis-clients/pc/cyvO9g/controle_technique_/autosur_montreuil_sous_bois"
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-3 px-4 py-2 bg-autosur-navy rounded-full hover:bg-autosur-navy/90 transition-colors ${className}`}
    >
      {/* Trustville official badge */}
      <img 
        src={trustvilleBadgeImg} 
        alt="Avis clients vérifiés par Trustville" 
        className="h-10 w-auto -ml-1"
        width={40}
        height={40}
      />
      
      {/* Rating section */}
      <div className="flex flex-col items-start">
        {/* Stars + Rating */}
        <div className="flex items-center gap-1.5">
          <div className="flex items-center gap-0.5">
            {[...Array(5)].map((_, i) => (
              <Star 
                key={i} 
                className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" 
              />
            ))}
          </div>
          <span className="font-heading font-bold text-white text-sm">4.9/5</span>
        </div>
        
        {/* Reviews count - underlined to show clickable */}
        <span className="text-white text-xs font-body underline underline-offset-2">
          40 avis clients
        </span>
      </div>
    </a>
  );
};
